/* eslint-disable */
__webpack_public_path__ = api_config.cdn;
/* eslint-enable */
